import { useNavigate } from "react-router-dom";

import img1 from "../resource/newfotos/foto1.png";
import img2 from "../resource/newfotos/foto3.png";
import img3 from "../resource/newfotos/foto2.png";
import img4 from "../resource/newfotos/foto4.png";
function ShopCategories() {
  const navigate = useNavigate();
  return (
    <div className="relative isolate px-6 pt-0 lg:px-8">
      <div
        aria-hidden="true"
        className="absolute inset-x-0 -z-10 transform-gpu overflow-hidden blur-3xl"
      >
        <div
          style={{
            clipPath:
              "polygon(74.1% 44.1%, 100% 61.6%, 97.5% 26.9%, 85.5% 0.1%, 80.7% 2%, 72.5% 32.5%, 60.2% 62.4%, 52.4% 68.1%, 47.5% 58.3%, 45.2% 34.5%, 27.5% 76.7%, 0.1% 64.9%, 17.9% 100%, 27.6% 76.8%, 76.1% 97.7%, 74.1% 44.1%)",
          }}
          className="relative left-[calc(50%-11rem)] aspect-[1155/678] w-[36.125rem] -translate-x-1/2 rotate-[30deg] bg-gradient-to-tr from-[#ff80b5] to-[#9089fc] opacity-50 sm:left-[calc(50%-30rem)] sm:w-[72.1875rem]"
        />
      </div>
      <div className="bg-inherit py-24 sm:py-32">
        <div className="mx-auto max-w-2xl px-6 lg:max-w-7xl lg:px-8">
          <p className="mx-auto mt-2 max-w-lg text-balance text-center text-4xl font-semibold tracking-tight text-gray-950 sm:text-5xl">
            Shop Categories
          </p>
          <div className="mt-10 grid gap-4 sm:mt-12 lg:grid-cols-3 lg:grid-rows-2">
            <div
              className="relative lg:row-span-2"
              onClick={() => navigate("/product/0")}
            >
              <div className="absolute inset-px rounded-lg bg-white lg:rounded-l-[2rem]"></div>
              <div className="relative flex h-full flex-col overflow-hidden rounded-[calc(theme(borderRadius.lg)+1px)] lg:rounded-l-[calc(2rem+1px)]">
                <div className="px-8 pb-3 pt-8 sm:px-10 sm:pb-0 sm:pt-10">
                  <p className="mt-2 text-2xl font-semibold tracking-tight text-gray-950 max-lg:text-center">
                    Big Blue Energy
                  </p>
                  <p className="mt-2 max-w-lg text-sm/6 text-gray-600 max-lg:text-center">
                    Our original recipes with loads of energy and tons of drink
                    flavors.
                  </p>
                </div>
                <div className="relative min-h-[15rem] w-full grow [container-type:inline-size] max-lg:mx-auto max-lg:max-w-sm">
                  <img
                    className="size-full object-cover object-full -translate-x-0 transition-all hover:scale-125"
                    src={img1}
                    alt=""
                  />
                </div>
              </div>
              <div className="pointer-events-none absolute inset-px rounded-lg shadow ring-1 ring-black/5 lg:rounded-l-[2rem]"></div>
            </div>
            <div
              className="relative max-lg:row-start-1"
              onClick={() => navigate("/product/1")}
            >
              <div className="absolute inset-px rounded-lg bg-white max-lg:rounded-t-[2rem]"></div>
              <div className="relative flex h-full flex-col overflow-hidden rounded-[calc(theme(borderRadius.lg)+1px)] max-lg:rounded-t-[calc(2rem+1px)]">
                <div className="px-8 pt-8 sm:px-10 sm:pt-10">
                  <p className="mt-2 text-2xl font-semibold tracking-tight text-gray-950 max-lg:text-center">
                    Big Blue LYTE
                  </p>
                  <p className="mt-2 max-w-lg text-sm/6 text-gray-600 max-lg:text-center">
                    All the excitment and flavor of our original recipes with
                    only half the caffeine.
                  </p>
                </div>
                <div className="size-full object-cover object-full translate-y-10 transition-all hover:scale-125">
                  <img
                    className="w-full lg:max-w-sm max-w-lg mx-auto"
                    src={img3}
                    alt=""
                  />
                </div>
              </div>
              <div className="pointer-events-none absolute inset-px rounded-lg shadow ring-1 ring-black/5 max-lg:rounded-t-[2rem]"></div>
            </div>
            <div
              onClick={() => navigate("/product/7")}
              className="relative max-lg:row-start-3 lg:col-start-2 lg:row-start-2"
            >
              <div className="absolute inset-px rounded-lg bg-white max-lg:rounded-t-[2rem]"></div>
              <div className="relative flex h-full flex-col overflow-hidden rounded-[calc(theme(borderRadius.lg)+1px)] max-lg:rounded-t-[calc(2rem+1px)]">
                <div className="px-8 pt-8 sm:px-10 sm:pt-10">
                  <p className="mt-2 text-2xl font-semibold tracking-tight text-gray-950 max-lg:text-center">
                    Big Blue Plus+
                  </p>
                  <p className="mt-2 max-w-lg text-sm/6 text-gray-600 max-lg:text-center">
                    The perfect mixture of hydration and energy.
                  </p>
                </div>
                <div className="size-full object-cover object-full translate-y-10 transition-all hover:scale-125">
                  <img
                    className="w-full lg:max-w-sm max-w-lg mx-auto"
                    src={img4}
                    alt=""
                  />
                </div>
              </div>
              <div className="pointer-events-none absolute inset-px rounded-lg shadow ring-1 ring-black/5 max-lg:rounded-t-[2rem]"></div>
            </div>
            <div
              className="relative lg:row-span-2"
              onClick={() => navigate("/product/2")}
            >
              <div className="absolute inset-px rounded-lg bg-white max-lg:rounded-b-[2rem] lg:rounded-r-[2rem]"></div>
              <div className="relative flex h-full flex-col overflow-hidden rounded-[calc(theme(borderRadius.lg)+1px)] max-lg:rounded-b-[calc(2rem+1px)] lg:rounded-r-[calc(2rem+1px)]">
                <div className="px-8 pb-3 pt-8 sm:px-10 sm:pb-0 sm:pt-10">
                  <p className="mt-2 text-2xl font-semibold tracking-tight text-gray-950 max-lg:text-center">
                    Big Blue Reload
                  </p>
                  <p className="mt-2 max-w-lg text-sm/6 text-gray-600 max-lg:text-center">
                    Load up on vitamins and minerals with our
                    electrolye/hydration drinks. Caffeine-free.
                  </p>
                </div>
                <div className="relative min-h-[15rem] w-full grow [container-type:inline-size] max-lg:mx-auto max-lg:max-w-sm">
                  <div className="-mb-px flex text-sm/6 font-medium text-gray-400">
                    <div className="border-b border-r border-b-white/20 border-r-white/10 bg-white/5 px-0 py-0 text-white">
                      <div>
                        <img
                          className="size-full object-cover object-full translate-y-8 lg:translate-y-24 transition-all hover:scale-125"
                          src={img2}
                          alt=""
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="pointer-events-none absolute inset-px rounded-lg shadow ring-1 ring-black/5 max-lg:rounded-b-[2rem] lg:rounded-r-[2rem]"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ShopCategories;
